import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPoland = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 256,
		cy: 256,
		r: 256,
		fill: "#f0f0f0"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#d80027",
		d: "M512 256a256 256 0 0 1-512 0"
	})]
});
export default SvgPoland;
